module.exports = __webpack_public_path__ + "img/Washability.a54108d7.svg";